import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

const { classNames } = Mobi2Go.helpers;

class LocationListing extends React.Component {
    static propTypes = {
        method: PropTypes.string.isRequired,
        onMethodClick: PropTypes.func.isRequired,
        location: PropTypes.instanceOf(Mobi2Go._class.Location).isRequired,
        t: PropTypes.func.isRequired,
        is_test_order: PropTypes.bool.isRequired,
    };

    shouldComponentUpdate = next_props => {
        const { location, method, is_test_order } = this.props;
        return (
            location.id !== next_props.location.id ||
            is_test_order !== next_props.is_test_order ||
            location.distance_to_customer !==
                next_props.location.distance_to_customer ||
            method !== next_props.method
        );
    };

    render() {
        const {
            t,
            location,
            method,
            onMethodClick,
            is_test_order,
        } = this.props;
        const minutes_to_asap_order = location.getMinutesToAsapOrderDatetime(
            method
        );
        const time_to_order = location.current_time.to(
            location.getAsapOrderDatetime(method)
        );
        const is_order_available_soon =
            location.isOpenForMethod(method) && minutes_to_asap_order < 120;
        const ordering_disabled =
            location.isInactive() ||
            location.isHidden() ||
            location.isLockedOut();
        const unable_to_order = !is_test_order && ordering_disabled;

        return (
            <div
                className="m2g-locations-finder-location-listing"
                data-is-open={is_order_available_soon && !ordering_disabled}
            >
                <div className="m2g-icon m2g-icon--location m2g-locations-finder-location-listing-marker-icon" />
                <div className="m2g-locations-finder-location-listing-details">
                    <div className="m2g-locations-finder-location-listing-name">
                        <div className="m2g-locations-finder-location-listing-name-text">
                            {location.name}
                        </div>
                    </div>

                    <div className="m2g-text--offset m2g-locations-finder-location-listing-address">
                        {location.getAddressString()}
                    </div>

                    {method === 'pickup' &&
                        location.distance_to_customer !== null &&
                        location.distance_to_customer <= 25 && (
                            <div
                                className={classNames(
                                    'm2g-locations-finder-location-listing-distance',
                                    'm2g-text--small',
                                    'm2g-text--offset'
                                )}
                            >
                                {t('distance_away', {
                                    distance:
                                        location.distance_to_customer_formatted,
                                })}
                            </div>
                        )}

                    {location.address.phone_number && (
                        <div className="m2g-locations-finder-location-listing-phone-number">
                            <div className="m2g-icon m2g-icon--phone m2g-locations-finder-location-listing-phone-number-icon" />
                            <a
                                href={`tel:${location.address.phone_number}`}
                                className="m2g-text--link m2g-locations-finder-location-listing-phone-number-text"
                            >
                                {location.address.phone_number}
                            </a>
                        </div>
                    )}
                </div>

                {method === 'delivery' &&
                    minutes_to_asap_order !== 0 &&
                    minutes_to_asap_order < 240 && (
                        <div className="m2g-locations-finder-location-listing-order-time">
                            <div className="m2g-icon m2g-icon--clock m2g-locations-finder-location-listing-order-time-icon" />
                            <div className="m2g-locations-finder-location-listing-order-time-text m2g-text--small m2g-text--offset">
                                {t('delivers', { time_to_order })}
                            </div>
                        </div>
                    )}

                <div className="m2g-locations-finder-location-listing-open-status">
                    <div className="m2g-locations-finder-location-listing-open-status-text">
                        {(() => {
                            if (location.isInactive()) {
                                return t('offline');
                            }
                            if (location.isHidden()) {
                                return t('hidden');
                            }
                            if (location.isLockedOut()) {
                                return t('disabled');
                            }
                            if (location.isOpenForMethod(method)) {
                                return t('open_now');
                            }
                            return t('closed');
                        })()}
                    </div>

                    {!location.isLockedOut() && !location.isInactive() && (
                        <div className="m2g-locations-finder-location-listing-open-status-message m2g-text--offset m2g-text--small">
                            {location.getClosingTimeSentence(method)}
                        </div>
                    )}
                </div>

                <div
                    style={{ display: 'none' }}
                    className="m2g-locations-finder-location-listing-opening-hours-link m2g-text--small"
                >
                    <span className="m2g-locations-finder-location-listing-opening-hours-link-icon m2g-icon m2g-icon--clock" />
                    {t('opening_hours')}
                </div>

                {location.isInactive() &&
                    location.offline_message &&
                    method !== 'delivery' && (
                        <div className="m2g-alert m2g-alert--warning m2g-locations-finder-location-listing-alert">
                            <span className="m2g-icon m2g-icon--exclamation-mark m2g-icon--medium m2g-locations-finder-location-listing-alert-icon" />
                            {location.offline_message}
                        </div>
                    )}

                {ordering_disabled && is_test_order && (
                    <div className="m2g-alert m2g-alert--warning m2g-locations-finder-location-listing-alert">
                        <span className="m2g-icon m2g-icon--info m2g-icon--medium m2g-locations-finder-location-listing-alert-icon" />
                        Test orders only
                    </div>
                )}

                {!unable_to_order && (
                    <div className="m2g-locations-finder-location-listing-order-methods">
                        {method === 'delivery' &&
                            location.order_methods.delivery && (
                                <div
                                    role="button"
                                    tabIndex="0"
                                    onKeyPress={() => {}}
                                    className={classNames(
                                        'm2g-locations-finder-location-listing-order-methods-delivery',
                                        'm2g-button',
                                        'm2g-button--primary'
                                    )}
                                    onClick={() => onMethodClick('delivery')}
                                >
                                    <div className="m2g-button-text">
                                        {is_order_available_soon
                                            ? t('order_now')
                                            : t('order_for_later')}
                                    </div>
                                </div>
                            )}

                        {method === 'pickup' && location.order_methods.pickup && (
                            <div
                                role="button"
                                tabIndex="0"
                                onKeyPress={() => {}}
                                className={classNames(
                                    'm2g-locations-finder-location-listing-order-methods-pickup',
                                    'm2g-button',
                                    'm2g-button--primary'
                                )}
                                onClick={() => onMethodClick('pickup')}
                            >
                                <div className="m2g-button-text">
                                    {is_order_available_soon
                                        ? t('order_now')
                                        : t('order_for_later')}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default forwardRefWithTranslation('locations.finder')(LocationListing);
